// MenuWithSubmenu.jsx
import React, { useState } from "react";
import PropTypes from "prop-types";
import { List, ListItemIcon, ListItemText, Collapse } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import SubmenuItem from "./SubMenuItem";
import StyledListItemButton from "./StyledListItemButton";

function MenuWithSubmenu({ title, icon, color, items }) {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <>
      <StyledListItemButton onClick={handleClick}>
        <ListItemIcon>
          {React.cloneElement(icon, { sx: { color } })}
        </ListItemIcon>
        <ListItemText primary={title} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </StyledListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {items.map((item) => (
            <SubmenuItem
              key={item.primary}
              icon={item.icon}
              color={item.color}
              primary={item.primary}
              to={item.to}
            />
          ))}
        </List>
      </Collapse>
    </>
  );
}

MenuWithSubmenu.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  color: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      primary: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
      icon: PropTypes.element.isRequired,
      color: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default MenuWithSubmenu;
